module.exports = __webpack_public_path__ + "assets/img/企业简介_04.0912de7a.jpg";